import { ColumnsFactory } from "../../../../../../shared/components/Grid/functions";

export const getColumnDefs = (perfilUser,filtro) => {
  const view_columnProfile = perfilUser!=='ADM';

  return [
    ColumnsFactory.TextColumn("Cod. Sg/Dn", "idDn"),
    ColumnsFactory.TextColumn("Sg/Dn", "direccionNegocio"),
    ColumnsFactory.TextColumn("Área", "area"),
    ColumnsFactory.TextColumn("Sociedad", "sociedad", {hide: (filtro===undefined || filtro.idSociedad===undefined)}),
    ColumnsFactory.TextColumn("Dni Responsable", "responsable", {hide: view_columnProfile}),
    ColumnsFactory.TextColumn("Nombre Responsable", "nombreResponsable",{hide: view_columnProfile}),
    ColumnsFactory.TextColumn("Dni", "dniUsuario"),
    ColumnsFactory.TextColumn("Nombre", "nombreUsuario"),
    ColumnsFactory.NumericColumn("Nº Partes", "nPartes",{ipkTotalizar: true}),
    ColumnsFactory.DecimalColumn("Horas Totales", "nHoras"),
    ColumnsFactory.NumericColumn("Nº Días Partes", "nDiasPartes",{ipkTotalizar: true})
  ];
};
